import { FullProjectTask, isTaskActive } from 'entities';

import { Collapse, Column, Row, ResponsiveRender } from 'components/Blocks';
import { UserAvatarGroup } from 'components/UserAvatar';
import { EntityStatusTag } from 'components/Entities';
import { Deadline, ExpectedDate } from 'pages/Projects/components/Deadline';

import { getFirstAndLastName, getFirstWord } from 'utils/text';
import { cn } from 'styles';

interface ProjectTasksProps {
  isOpen?: boolean;
  tasks: FullProjectTask[];

  projectStatus: string;
}

export function ProjectTasks({ isOpen, tasks, projectStatus }: ProjectTasksProps) {
  return (
    <Collapse expanded={isOpen} onlyRenderIfExpanded>
      <Column gap="2" className="mt-4 px-1">
        {tasks.map((task) => (
          <div
            key={task.id}
            className={cn(
              'grid grid-cols-5 items-center rounded-lg bg-muted/30 p-2',
              'tablet:grid-cols-2 tablet:gap-x-3 tablet:gap-y-6 ',
            )}
          >
            <p className="phone:text-sm">{task.name}</p>

            <Row
              gap="2"
              className="col-span-2 ml-[30%] tablet:col-span-1 tablet:ml-0 tablet:justify-end phone:flex-col phone:items-end phone:gap-0"
            >
              <UserAvatarGroup
                users={[task.owner, task.subOwner]}
                size={32}
                className="justify-center"
                avatarClassName="text-sm small_phone:!size-8"
                showNameOnHover={false}
              />

              <p className="text-center phone:text-xs">
                {task.subOwner
                  ? `${getFirstWord(task.owner.name)} & ${getFirstWord(task.subOwner.name)}`
                  : getFirstAndLastName(task.owner.name)}
              </p>
            </Row>

            <div className="justify-self-center tablet:justify-self-start">
              <ResponsiveRender
                defaultContent={<Deadline target={task} />}
                responsiveContent={
                  <ExpectedDate
                    date={task.expectedDate}
                    isActive={isTaskActive(projectStatus, task)}
                    className="text-xs"
                  />
                }
              />
            </div>

            <EntityStatusTag
              target="task"
              status={task.status}
              className="h-8 w-40 justify-self-end phone:h-auto phone:w-fit phone:px-2"
            />
          </div>
        ))}
      </Column>
    </Collapse>
  );
}
